import React from 'react';
import getHostDomain from 'helpers/getHostDomain';
import SplitPageContainer from 'components/SplitPageContainer';
import SplitPageRight from 'components/SplitPageRight';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

function SetupAccount() {
  const classes = useStyles();
  const hostDomain = getHostDomain();

  return (
    <SplitPageContainer>
      <SplitPageRight>
        <Typography className={classes.headline}>Let's get you set up</Typography>
        <Typography className={classes.textBody}>
          We are excited that you are ready to start your Sift journey and look forward to seeing
          how Sift can help your organization connect. Now that you have begun your Sift journey,
          let’s make the most of your Sift experience by getting your Sift account together.
        </Typography>
        <Button
          className={classes.button}
          variant="contained"
          color="secondary"
          href={`https://app.${hostDomain}.com/admin`}
        >
          Set up your sift account
        </Button>
      </SplitPageRight>
    </SplitPageContainer>
  );
}

const useStyles = makeStyles(theme => {
  return {
    headline: {
      marginBottom: theme.spacing(1),
      fontSize: 34,
      lineHeight: '43px',
      letterSpacing: '0.25px',
      [theme.breakpoints.down('lg')]: {
        fontSize: 24,
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(0.5),
      },
    },
    textBody: {
      marginBottom: theme.spacing(7.375),
      fontSize: 16,
      lineHeight: '24px',
      letterSpacing: '0.15px',
      maxWidth: 745,
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(3),
        fontSize: 14,
      },
    },
    button: {},
  };
});

export default SetupAccount;
